import React, { useRef } from 'react';
import { Form } from 'react-bootstrap';
import Input from '../../Input';
import AddressSearchAutocompleteInput from '../../AddressSearchAutocompleteInput/AddressSearchAutocompleteInput.view';
import ReactPhoneInput from 'react-phone-input-2';
import { isStringNotNull } from '../../../utils/tools';
import { formatPhoneService } from '../../../utils/shopUtils';
import { ShopInfoSectionProps } from '../LaunchingForm.types';

const ShopInfoSection = ({
  handleSelectAddressShop,
  errors,
  setPhoneValidityFromLib,
  isPhoneIncorrect,
  formData,
  onFieldChange,
  validateField,
}: ShopInfoSectionProps) => {
  const inputElementRef = useRef<any>(null);
  const value = formatPhoneService({}, formData.shop.number);

  return (
    <div className=''>
      <h4 className='mb-2 font-weight-bold'>Informations sur le magasin</h4>
      <div className='mx-3'>
        <Form.Row>
          <Form.Group className='col mb-2'>
            <Input
              label='Nom du magasin'
              type='text'
              id='name'
              placeholder='My shop'
              value={formData.shop.name}
              onChange={(e) => onFieldChange('shop.name', e.target.value)}
              onBlur={(e) => validateField('shop.name', e.target.value)}
              fullWidth
              error={!!errors.shop?.name}
              required
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group className='col mb-2'>
            <AddressSearchAutocompleteInput
              typedAddress={formData.shop.typedAddress || ''}
              setTypedAddress={(value) => {
                onFieldChange('shop.typedAddress', value);
                if (formData.shop.address) {
                  onFieldChange('shop.address', null);
                }
              }}
              handleAddressSelection={(selectedAddressValue, placeId) => handleSelectAddressShop(selectedAddressValue, placeId)}
              handleAddressInputFormControlError={(status, clearSuggestions) => null}
              hasErrorAddressMessage={!!errors.shop?.address}
              inputElementRef={inputElementRef}
              animatePlaceholder={''}
              isFilledAddressValid={!!formData.shop.address && !!formData.shop.address.city}
              label={'Adresse du magasin'}
              autoFocus={false}
              required
              onBlur={(e) => validateField('shop.typedAddress', e.target.value)}
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group className='col mb-2'>
            <Input
              label='Email'
              type='text'
              id='email'
              fullWidth
              placeholder='prenom.nom@exemple.com'
              value={formData.shop.email}
              onChange={(e) => onFieldChange('shop.email', e.target.value)}
              onBlur={(e) => validateField('shop.email', e.target.value)}
              error={!!errors.shop?.email}
              required
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group className='col mb-3 mt-3'>
            <ReactPhoneInput
              placeholder='Téléphone'
              countryCodeEditable={false}
              inputStyle={{
                width: '100%',
                boxSizing: 'border-box',
              }}
              country='fr'
              value={value}
              preferredCountries={['fr', 'mc']}
              regions={['europe']}
              inputClass={`${(!isStringNotNull(value) || !!errors.shop?.number || isPhoneIncorrect) ? 'is-invalid' : ''}`}
              onChange={(phoneValue) => onFieldChange('shop.number', phoneValue)}
              isValid={setPhoneValidityFromLib}
            />
            {((!isStringNotNull(value) || !!errors.shop?.number || isPhoneIncorrect)) && (
              <div className="invalid-feedback-block">Veuillez fournir un téléphone valide</div>
            )}
          </Form.Group>
        </Form.Row>
      </div>
    </div>
  );
};

export default ShopInfoSection;
